module.exports = __webpack_public_path__ + "static/media/share-3.25b55172.png";